module.exports = __webpack_public_path__ + "img/business_dummy.00d6277f.png";